import http from "./utils";
import { overviewOriginType } from '@/pages/opinion/types/performance';
import { mockPrefix, prefix } from './constants';
export const getStreamingTrends: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/streaming/trends`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

/**
 * TODO: 其他系统使用
 * @param payload
 * @returns
 */
export const getStreamingChannelShare: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/streaming/channel`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getStreamingChannelShareTrends: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/streaming/channel_trends`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getStreamingDownloadTrends: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/streaming/download`,
    method: 'post',
    data: payload,
    responseType: 'arraybuffer',
    responseEncoding: 'utf8',
    rawData: true,
  }) as Promise<overviewOriginType>;
};

export const getStreamingChannelLatestDate: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/streaming/channel_latest_date`,
    method: 'post',
    data: payload,
    errorHandler: true,
  }) as Promise<overviewOriginType>;
};

export const getInfluencerKeyMetrics: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/kol/key_metrics`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getInfluencerChartDate: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/kol/timeline`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};

export const getInfluencerTableDate: (
  payload: any,
) => Promise<overviewOriginType> | overviewOriginType = (payload) => {
  return http({
    url: `${prefix}/kol/list`,
    method: 'post',
    data: payload,
  }) as Promise<overviewOriginType>;
};
